/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Button as MaterialUiButton } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  noAutoWidth: {
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    borderRadius: 30,
    fontSize: '1.5rem',
    height: '3rem',
    width: '15rem',
    [theme.breakpoints.only('md')]: {
      width: '13rem',
    },
  },
  autoWidth: {
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    borderRadius: 30,
    fontSize: '1.5rem',
    height: '3rem',
  }
}));

const FillButton = ({ autoWidth, disabled, onClick, text }) => {
  const classes = useStyles();

  return (
    <MaterialUiButton
      className={autoWidth ? classes.autoWidth : classes.noAutoWidth}
      color="primary"
      disabled={disabled}
      onClick={onClick}
      variant="contained"
    >
      {text}
    </MaterialUiButton>
  )
}

FillButton.propTypes = {
  autoWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
}

FillButton.defaultProps = {
  autoWidth: false,
  disabled: false,
  onClick: () => {}
}

export default FillButton;
